export default {"src":"/uk/_next/static/media/biometricsIcon.e9d86871.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};